import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pay-wechat",
  "use": "icon-pay-wechat-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pay-wechat\"><defs><style type=\"text/css\"></style></defs><path d=\"M390.384941 644.818824c-61.319529 36.984471-70.415059-20.781176-70.415059-20.781177L243.169882 429.899294c-29.515294-92.280471 25.6-41.622588 25.6-41.622588s47.284706 38.791529 83.245177 62.403765c35.84 23.612235 76.8 6.927059 76.8 6.927058l502.121412-251.060705C838.294588 81.679059 685.236706 0 512 0 229.195294 0 0 217.328941 0 485.376c0 154.202353 75.896471 291.358118 194.078118 380.385882l-21.263059 132.698353s-10.420706 38.731294 25.6 20.781177c24.576-12.227765 87.100235-56.199529 124.385882-82.883765a535.190588 535.190588 0 0 0 189.199059 34.334118c282.744471 0 512-217.268706 512-485.315765v-0.060235a462.607059 462.607059 0 0 0-53.609412-216.064c-159.924706 104.327529-532.058353 346.654118-580.005647 375.567059z\" fill=\"#24AF41\" p-id=\"5775\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pay-wechat.svg
// module id = Jr3b
// module chunks = 24